<ng-container *ngIf="!isDatePickerEnabled; else datepicker">
    <div class="input-group" (click)="!model.options.readonly && openCalendar()">
        <input
            class="form-control pe-0"
            #dateInput
            [type]="model.options.displayOnlyMonthYear ? 'month' : 'date'"
            [formControl]="dateInputControl"
            paceCoreValidationMessage
            [validation]="dateInputControl"
            [attr.aria-label]="ariaLabel"
            [ngClass]="{ 'invalid-date': !this.model.value.isValid() }"
        />
        <span class="input-group-text" (click)="dateInput.focus()"><fa-icon [icon]="faCalendar"></fa-icon></span>
    </div>
</ng-container>
<ng-template #datepicker>
    <input
        type="text"
        placeholder="Datepicker"
        class="form-control date-picker-input"
        [bsConfig]="{
            isAnimated: true,
            adaptivePosition: true,
            containerClass: 'theme-dark-blue',
            dateInputFormat: dateFormat,
            showWeekNumbers: false,
        }"
        [datesEnabled]="datesEnabled"
        (keydown)="$event.preventDefault()"
        [formControl]="dateInputControl"
        [daysDisabled]="daysDisabled"
        [placement]="(isMobile$ | async) ? 'bottom' : 'right'"
        bsDatepicker
        paceCoreValidationMessage
        [validation]="dateInputControl"
        [attr.aria-label]="ariaLabel"
        [ngClass]="{ 'invalid-date': !this.model.value.isValid() }"
    />
</ng-template>
